<template>
	<div class="repairWay-container">
		
		
				<!-- list -->
		<div class="box2 mainCont">
	      
            <div class="b_min" v-for="(item,index) in list" :key="index" v-if="index==0" @click="goDetail(item)">
				<img class="img" :src="item.img" alt="">
				<h4 class="text-ellipsisc2">{{item.name}}</h4>
				<p class="text-ellipsisc3">{{item.miaoshu}}</p>
				<div class="time"><i class="iconfont icon-shijian"></i> <span>{{item.createTime}}</span></div>
			</div>  


	 
           
		   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>0&&index<11" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>

            <div class="b_left">
				<div class="item" v-for="(item,index) in list" :key="index" @click="goDetail(item)" v-if="index>11&&index<16">
					<img class="img" :src="item.img" alt="">
					<div class="txt">
						<h4 class="text-ellipsisc2">{{item.name}}</h4>
						<p><i class="iconfont icon-shijian"></i> <span>{{item.createTime}}</span></p>
					</div>
				</div>
			</div>



			
		
		</div>
			
	<div class="mainCont"  v-if="!loading&&list.length==0">
			<el-empty description="暂无"></el-empty>
		</div>
	     
       <div class="box2 mainCont">
			   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>16&&index<27" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>
           
		   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>27&&index<38" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>





		   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>38&&index<49" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>
		
		</div>


   
       <div class="box2 mainCont">
			   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>49&&index<60" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>
           
		   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>60&&index<71" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>





		   	<div class="b_right">
				<div class="item" v-for="(item,index) in list" :key="index" v-if="index>71&&index<82" @click="goDetail(item)">
					<h4 class="text-ellipsisc">{{item.name}}</h4>
					<p>{{item.createTime}}</p>
				</div>
			</div>
		
		</div>

		
		
	</div>
</template>
<script>
	
	import {getXlxzhList,getDictList} from '@/api/api'
	import {getDay2,getDay3} from "@/utils/utils.js"
export default {
	name: 'repairWay',
	data() {
		return {
			typeList:[],
			key:'',
			list:[],
			loading:true,
			type:'',
			total:0,
			pageIndex:1,
			pageSize:10,
		};
	},
	mounted() {
		console.log('1111')
		
	},
	activated(){
		console.log('wxh')
		this.type = this.$route.query.type||'';
		this.getDictList();
		this.getXlxzhList();
	},
	methods: {
		getDictList(){
			getDictList({code: "gzdmCode"}).then(res => {
				this.typeList = res.data;
			})
		},
		typeBtn(item){
			this.type = item.dictValue;
			this.pageIndex = 1;
			this.getXlxzhList();
		},
		getXlxzhList(){
			this.loading = true;
			getXlxzhList({type:this.type,key:this.key,pageIndex:this.pageIndex,pageSize: '90'}).then(res => {
				let list = res.data;
				list.forEach(ele=>{
					if(ele.createTime){
						ele.createTime = getDay2(ele.createTime)
						let obj = getDay3(ele.createTime)
						ele.year = obj.year;
						ele.day = obj.day
					}
				})
				this.total = res.total||0;
				this.list = list;
				this.loading = false;
			})
		},
		// 分页
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getXlxzhList();
		},
		goDetail(item){
			this.$router.push({
			path: '/repairWay/detail',
				query: {
					id: item.id
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.repairWay-container{background-color: #F5F8F9;padding:50px 0 70px;
	.box1{display: flex;justify-content: space-between;padding-bottom: 50px;
		.left{width: 68.5%;padding-right: 42px;
			.item{display: flex;align-items: center;cursor: pointer;
				.img{width: 363px;height: 280px;background: #D9D9D9;border-radius: 8px;overflow: hidden;flex: 0 0 363px;
					img{width: 100%;height: 100%;border-radius: 8px;object-fit: cover;transition: all .3s;}
				}
				.txt{padding-left: 36px;
					h4{color: #1F263F;font-size: 20px;font-weight: bold;margin-top: 13px;transition: all .3s;}
					p{color: #A4A9B7;font-size: 14px;line-height: 26px;margin-top: 16px;transition: all .3s;}
					.time{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;margin-top: 30px;
						i{margin-right: 6px;font-size: 12px;}
					}
				}
				&:hover{
					img{transform: scale(1.2);}
					h4{color: #2F78FF;}
					p{color: #333;}
				}
			}
			ul{display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;
				li{margin-top: 30px;width: 48%;display: flex;align-items: center;cursor: pointer;
					.img{width: 108px;height: 82px;background: #D9D9D9;border-radius: 8px;overflow: hidden;flex: 0 0 108px;
						img{width: 100%;height: 100%;border-radius: 8px;object-fit: cover;transition: all .3s;}
					}
					.txt{padding-left: 16px;
						h4{color: #333333;font-size: 16px;font-weight: bold;transition: all .3s;}
						.time{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;margin-top: 10px;
							i{margin-right: 6px;font-size: 12px;}
						}
					}
					&:hover{
						img{transform: scale(1.2);}
						h4{color: #2F78FF;}
					}
				}
			}
		}
		.right{width: 31.5%;background: #F5F8F9;border-radius: 8px;padding: 16px;
			h3{color: #1F263F;font-size: 20px;font-weight: bold;margin-bottom: 16px;}
			ul{
				li{margin-bottom: 30px;display: flex;align-items: center;cursor: pointer;
					&:last-child{margin-bottom: 0;}
					.img{width: 108px;height: 82px;background: #D9D9D9;border-radius: 8px;overflow: hidden;flex: 0 0 108px;
						img{width: 100%;height: 100%;border-radius: 8px;object-fit: cover;transition: all .3s;}
					}
					.txt{padding-left: 16px;
						h4{color: #333333;font-size: 16px;transition: all .3s;}
						.time{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;margin-top: 10px;
							i{margin-right: 6px;font-size: 12px;}
						}
					}
					&:hover{
						img{transform: scale(1.2);}
						h4{color: #2F78FF;}
					}
				}
			}
		}
	}
	.box2{margin-top: 40px;display: flex;justify-content: space-between;
		.b_left{width: 377px;
			.item{display: flex;align-items: center;cursor: pointer;margin-bottom: 30px;
				&:last-child{margin-bottom: 0;}
				.img{width: 108px;height: 82px;background: #D9D9D9;border-radius: 8px;}
				.txt{margin-left: 16px;flex: 1;display: flex;justify-content: space-between;flex-flow: column;height: 70px;
					h4{color: #333333;font-size: 16;width: 253px;font-weight: bold;line-height: 20px;}
					p{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;
						i{margin-right: 6px;font-size: 12px;}
					}
				}
				&:hover{
					.txt h4{color: #2F78FF;}
				}
			}
		}
		.b_min{width: 380px;
			.img{width: 380px;height: 214px;background: #D9D9D9;border-radius: 8px;}
			h4{color: #1F263F;font-size: 20px;font-weight: bold;margin-top: 16px;transition: all .3s;}
			p{color: #A4A9B7;font-size: 14px;line-height: 26px;margin-top: 16px;transition: all .3s;}
			.time{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;margin-top: 16px;
				i{margin-right: 6px;font-size: 12px;}
			}
			&:hover{
				h4{color: #2F78FF;}
				p{color: #333;}
			}
		}
		.b_right{width: 370px;
			.item{display: flex;align-items: center;justify-content: space-between;cursor: pointer;margin-bottom: 24px;
				&:last-child{margin-bottom: 0;}
				h4{color: #333333;font-size: 16px;width: 270rpx;transition: all .3s;}
				p{color: #A4A9B7;font-size: 12px;transition: all .3s;}
				&:hover{
					h4{color: #2F78FF;}
					p{color: #333;}
				}
			}
		}
	}
	
	.box3{padding-top: 30px;
		ul{
			li{margin-bottom: 30px;display: flex;align-items: center;cursor: pointer;
				&:last-child{margin-bottom: 0;}
				.img{width: 207px;height: 145px;border-radius: 8px;overflow: hidden;
					img{width: 100%;border-radius: 8px;transition: all .3s;}
				}
				.txt{flex: 1;padding-left: 24px;
					h4{color: #1F263F;font-size: 20px;font-weight: bold;margin-bottom: 10px;transition: all .3s;}
					p{color: #A4A9B7;font-size: 14px;line-height: 26px;margin-bottom: 24px;}
					.time{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;
						i{margin-right: 6px;font-size: 12px;}
					}
				}
				&:hover{
					img{transform: scale(1.2);}
					h4{color: #2F78FF;}
				}
			}
		}
	}
	.pageBox{display: flex;align-items: center;justify-content: space-around;margin-bottom: 30px;}


   /* 为每个 box2 mainCont 加入分割线 */
    .box2.mainCont {
        border-bottom: 1px solid #E0E0E0; /* 灰色分割线 */
        padding-bottom: 20px; /* 添加底部空间 */
    }

    /* 为最后一个 box2.mainCont 去掉分割线 */
    .box2.mainCont:last-child {
        border-bottom: none;
        margin-bottom: 20px; /* 增加底部空白 */
    }


}
</style>


// WEBPACK FOOTER //
// src/views/repairWay/index.vue